<template>
  <div class="portalApplication">
    <el-table :data="tableData" tooltip-effect="light" style="width: 100%" :empty-text="currentLanguage.emptyText">
      <el-table-column
        :label="currentLanguage.appname"
        prop="clientName"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        :label="currentLanguage.appurl"
        prop="rootUrl"
        class-name="rootUrl"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span @click="openUrl(scope.row.rootUrl)">{{
              scope.row.rootUrl
            }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="enable"
        :label="currentLanguage.appstate"
        width="120px"
        align="center"
      >
        <template slot-scope="scope">
          <el-switch :value="scope.row.enable" disabled></el-switch>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, prev, pager, next"
      :page-size="pageSize"
      :total="total"
      @current-change="pageChange"
    >
    </el-pagination>
  </div>
</template>

<script>
import language from "@/assets/messages/language"
import APIS from "@/apis/clientManage.js"
let currentLanguage = {}

export default {
  data() {
    return {
      tableData: [],
      enterpriseId: "",
      breadcrumb: [
        {
          label: ''
        }
      ],
      pageSize: 10,
      pageNum: 1,
      total: 0,
      realmName: this.$realm,
      currentClientId: "",
      accountName: ""
    }
  },
  computed: {
    // 404页面不展示导航菜单
    currentLanguage() {
      currentLanguage = language.languageJson[this.$store.state.currentLanguage]
      return currentLanguage
    }
  },
  watch: {
    // 监听currentModel变化，确保模式切换时breadcrumb能更新
    '$store.state.currentModel'() {
      this.updateBreadcrumb()
    },
    // 监听语言变化，更新breadcrumb
    '$store.state.currentLanguage'() {
      this.updateBreadcrumb()
    },
    // 监听currentLanguage computed变化，更新breadcrumb
    currentLanguage: {
      handler() {
        this.updateBreadcrumb()
      },
      immediate: true
    }
  },
  created() {
    try {
      this.accountName = this.$keycloak.tokenParsed.preferred_username
    } catch (error) {
      console.log(error)
    }
    // 确保breadcrumb在created时更新
    this.updateBreadcrumb()
  },
  mounted() {
    if (this.accountName && this.realmName) {
      this.getClientList()
    }
    // 在mounted时再次更新breadcrumb，确保显示正确
    this.$nextTick(() => {
      this.updateBreadcrumb()
    })
  },
  methods: {
    // 更新breadcrumb到store
    updateBreadcrumb() {
      // 更新data中的breadcrumb
      if (this.currentLanguage && this.currentLanguage.apptitle) {
        this.breadcrumb = [
          {
            label: this.currentLanguage.apptitle
          }
        ]
        // 更新到store
        this.$store.commit("update_breadcrumb", this.breadcrumb)
      }
    },
    // 查询账户列表
    async getClientList() {
      let params = {
        pageSize: this.pageSize,
        pageNum: this.pageNum
      }
      let { status, data } = await APIS.getPortalClients(
        this.realmName,
        this.accountName,
        {
          params
        }
      )
      this.total = 0
      this.tableData = []
      if (status === 0) {
        this.total = data.totalCount || 0
        this.tableData = []
        if (data && data.data) {
          this.tableData = data.data.map((item, index) => {
            return {
              index: index,
              clientName: item.name,
              rootUrl: item.rootUrl,
              enable: item.enabled,
              clientID: item.clientId,
              id: item.id
            }
          })
        }
      }
    },
    // 翻页
    pageChange(currentPage) {
      this.pageNum = currentPage
      this.getClientList()
    },
    openUrl(url) {
      window.open(url, "_blank")
    }
  }
}
</script>

<style lang="scss">
.portalApplication {
}
</style>
